import { Component, OnInit, output, inject, ChangeDetectionStrategy } from "@angular/core";
import { Status } from "../../master-data/master-data.model";
import { ActivatedRoute } from "@angular/router";
import { MasterDataService } from "../../master-data/master-data-service";

@Component({
  selector: "app-statuses-selector",
  templateUrl: "./statuses-selector.component.html",
  styleUrls: ["./statuses-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StatusesSelectorComponent implements OnInit {
  private masterDataService = inject(MasterDataService);
  private route = inject(ActivatedRoute);

  readonly selectedStatus = output<Status>();
  statuses: Status[];

  ngOnInit(): void {
    this.statuses = [...this.route.snapshot.data.statuses];
    this.statuses.sort((a, b) =>
      a.metaId > b.metaId ? 1 : b.metaId > a.metaId ? -1 : 0
    );
  }

  selectStatus(status: Status) {
    this.selectedStatus.emit(status);
  }
}
